"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var datapoints_1 = require("./datapoints");
var setGetInboxRuleRequestStatus_1 = require("./helpers/setGetInboxRuleRequestStatus");
var getInboxRulesService_1 = require("../services/getInboxRulesService");
var store_1 = require("../store/store");
var mobx_1 = require("mobx");
var owa_analytics_1 = require("owa-analytics");
var owa_analytics_2 = require("owa-analytics");
var DraggableItemTypes_1 = require("owa-dnd/lib/utils/DraggableItemTypes");
var legacy_1 = require("satcheljs/lib/legacy");
var logInboxRuleInformation_1 = require("../utils/logInboxRuleInformation");
/**
 * Gets inbox rules and stores them in the inboxRules options store
 */
// Task 20143: Full error handling / success notification support
exports.default = legacy_1.select({
    optionState: function () { return store_1.default.inboxRulesListState; },
})(legacy_1.action('getInboxRules', datapoints_1.default.getInboxRulesDatapoint)(function getInboxRules(state) {
    var optionState = state.optionState;
    setGetInboxRuleRequestStatus_1.default(1 /* Pending */);
    optionState.inboxRuleIds = [];
    optionState.inboxRules = mobx_1.map({});
    var dataPoint = owa_analytics_2.returnTopExecutingActionDatapoint();
    return getInboxRulesService_1.default()
        .then(function (response) {
        if (response.WasSuccessful) {
            setGetInboxRuleRequestStatus_1.default(2 /* Complete */);
            var inboxRuleCollection = response.InboxRuleCollection.InboxRules;
            var _a = datapoints_1.default.numInboxRules.datapoint, eventName = _a.name, customData = _a.customData;
            owa_analytics_1.logUsage(eventName, customData(inboxRuleCollection.length));
            for (var i = 0; i < inboxRuleCollection.length; i++) {
                addInboxRuleToStore(inboxRuleCollection[i], optionState);
                if (!optionState.hasLoggedGetInboxRulesInformation) {
                    logInboxRuleInformation_1.default(inboxRuleCollection[i], 'GetInboxRules');
                }
            }
            optionState.hasLoggedGetInboxRulesInformation = true;
        }
        else {
            var errorMessage = response.ErrorMessage
                ? response.ErrorMessage
                : 'Response WasSuccessful was false';
            setGetInboxRuleRequestStatus_1.default(3 /* Error */);
            dataPoint.endWithError(owa_analytics_2.DatapointStatus.ServerError, new Error(errorMessage));
        }
    })
        .catch(function (error) {
        setGetInboxRuleRequestStatus_1.default(3 /* Error */);
        dataPoint.endWithError(owa_analytics_2.DatapointStatus.ServerError, error.message);
    });
}));
var addInboxRuleToStore = legacy_1.action('addInboxRuleToStore')(function addInboxRuleToStore(inboxRule, optionState) {
    optionState.inboxRuleIds.push(inboxRule.Identity.RawIdentity);
    // transform inbox rule to InboxRuleRowType and add to map
    optionState.inboxRules.set(inboxRule.Identity.RawIdentity, tslib_1.__assign({}, inboxRule, { drop: {
            isDragOver: false,
            draggableItemType: DraggableItemTypes_1.DraggableItemTypes.InboxRule,
        } }));
});
//# sourceMappingURL=getInboxRules.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/actions/getInboxRules.js
// module id = 3754
// module chunks = 2